<ng-container *ngIf="spotlight$ | async as spotlights">
    <ng-container *ngIf="spotlights && spotlights.length > 0">
        <div class="home-hero">
            <img class="threads" src="/assets/images/home/home-hero/threads.svg" aria-hidden />

            <div class="hero-content">
                <div class="hero-heading">
                    <h1>{{ spotlights[0]?.title }}</h1>
                    <h2>{{ spotlights[0]?.description }}</h2>
                </div>
                <div class="actions">
                    <button (click)="signInWithRedirect($event)" target="_blank" [matTooltip]="spotlights[0]?.label">
                        {{ spotlights[0]?.label }}
                    </button>
                    <a [routerLink]="'/' + signUpRoute">{{ spotlights[0]?.second_label }}</a>
                </div>
            </div>

            <ng-container *appDesktop>
                <app-hero-name-tag
                    class="left"
                    [name]="spotlights[0]?.heroName"
                    [tag]="spotlights[0]?.heroTag"
                    [badgeSrc]="spotlights[0]?.heroBadge"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription }}</app-hero-name-tag
                >
                <app-hero-name-tag
                    class="right"
                    [name]="spotlights[0]?.heroName2"
                    [tag]="spotlights[0]?.heroTag2"
                    [badgeSrc]="spotlights[0]?.heroBadge2"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription2 }}</app-hero-name-tag
                >
                <img class="persons-combined" [src]="spotlights[0]?.desktopThumbnail" alt="Featured Orchestrators" />
            </ng-container>
            <ng-container *appTabletPortrait>
                <app-hero-name-tag
                    class="left"
                    [name]="spotlights[0]?.heroName"
                    [tag]="spotlights[0]?.heroTag"
                    [badgeSrc]="spotlights[0]?.heroBadge"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription }}</app-hero-name-tag
                >
                <app-hero-name-tag
                    class="right"
                    [name]="spotlights[0]?.heroName2"
                    [tag]="spotlights[0]?.heroTag2"
                    [badgeSrc]="spotlights[0]?.heroBadge2"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription2 }}</app-hero-name-tag
                >
                <img class="persons-combined" [src]="spotlights[0]?.desktopThumbnail" alt="Featured Orchestrators" />
            </ng-container>
            <ng-container *appTabletLandscape>
                <app-hero-name-tag
                    class="left"
                    [name]="spotlights[0]?.heroName"
                    [tag]="spotlights[0]?.heroTag"
                    [badgeSrc]="spotlights[0]?.heroBadge"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription }}</app-hero-name-tag
                >
                <app-hero-name-tag
                    class="right"
                    [name]="spotlights[0]?.heroName2"
                    [tag]="spotlights[0]?.heroTag2"
                    [badgeSrc]="spotlights[0]?.heroBadge2"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription2 }}</app-hero-name-tag
                >
                <img class="persons-combined" [src]="spotlights[0]?.desktopThumbnail" alt="Featured Orchestrators" />
            </ng-container>
            <div *appMobile class="mobile-orchestrators">
                <img [src]="spotlights[0]?.mobileThumbnail" alt="Featured Orchestrators" />
                <app-hero-name-tag
                    class="mobile-left"
                    [name]="spotlights[0]?.heroName"
                    [tag]="spotlights[0]?.heroTag"
                    [badgeSrc]="spotlights[0]?.heroBadge"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription }}</app-hero-name-tag
                >
                <app-hero-name-tag
                    class="mobile-right"
                    [name]="spotlights[0]?.heroName2"
                    [tag]="spotlights[0]?.heroTag2"
                    [badgeSrc]="spotlights[0]?.heroBadge2"
                    [hasDescription]="true"
                    >{{ spotlights[0]?.heroDescription2 }}</app-hero-name-tag
                >
            </div>

            <img *appDesktop class="spotlight" src="/assets/images/home/home-hero/spotlight.svg" aria-hidden />
            <img
                *appDesktop
                class="spotlight-background"
                src="/assets/images/home/home-hero/spotlight-background.svg"
                aria-hidden />

            <img *appTabletLandscape class="spotlight" src="/assets/images/home/home-hero/spotlight.svg" aria-hidden />
            <img
                *appTabletLandscape
                class="spotlight-background"
                src="/assets/images/home/home-hero/spotlight-background.svg"
                aria-hidden />

            <img *appTabletPortrait class="spotlight" src="/assets/images/home/home-hero/spotlight.svg" aria-hidden />
            <img
                *appTabletPortrait
                class="spotlight-background"
                src="/assets/images/home/home-hero/spotlight-background.svg"
                aria-hidden />

            <img
                *appMobile
                class="spotlight-mobile"
                src="/assets/images/home/home-hero/spotlight-mobile.svg"
                aria-hidden />
            <img class="stage" src="/assets/images/home/home-hero/stage-single.svg" aria-hidden />
            <img *appMobile class="stage-2" src="/assets/images/home/home-hero/stage-single.svg" aria-hidden />
        </div>
    </ng-container>
</ng-container>
